import React from 'react';
import Button from 'react-bootstrap/Button';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

export const ExportCSV = ({ csvData, fileName, convertDate = false, name = '', className = '' }) => {
	const fileType =
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
	const fileExtension = '.xlsx';

	const exportToCSV = (csv_data, fileName) => {
		let dataInfo = [...csv_data];

		if (convertDate) {
			dataInfo = dataInfo.map((data) => {
				return {
					...data,
					entrada: data.entrada ? new Date(data.entrada).toLocaleString() : '',
					salida: data.salida ? new Date(data.salida).toLocaleString() : ''
				};
			});
		}

		const ws = XLSX.utils.json_to_sheet(dataInfo);
		const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
		const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const data = new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, fileName + fileExtension);
	};

	return (
		<Button variant='success' className={className} onClick={(e) => exportToCSV(csvData, fileName)}>
			{name || 'Exportar'}
		</Button>
	);
};
